<div
  #modalElement
  role="document"
  class="ant-modal"
  (mousedown)="onMousedown()"
  [ngClass]="modalConfig.modalClassName!"
  [ngStyle]="modalConfig.modalStyle!"
  [style.width]="modalConfig?.modalWidth! | nzToCssUnit">
  <div class="ant-modal-content">
    <button *ngIf="modalConfig.modalClosable" ui-modal-close (click)="onCloseClick()"></button>
    <div class="ant-modal-body" [ngStyle]="modalConfig.modalBodyStyle!">
      <div class="ant-modal-confirm-body-wrapper">
        <div class="ant-modal-confirm-body">
          <i nz-icon [nzType]="modalConfig.modalIconType!"></i>
          <span class="ant-modal-confirm-title">
            <ng-container *nzStringTemplateOutlet="modalConfig.title">
              <span [innerHTML]="modalConfig.title"></span>
            </ng-container>
          </span>
          <div class="ant-modal-confirm-content">
            <ng-template cdkPortalOutlet></ng-template>
            <div *ngIf="isStringContent" [innerHTML]="modalConfig.modalContent"></div>
          </div>
        </div>
        <div class="ant-modal-confirm-btns">
          <button
            *ngIf="modalConfig.modalCancelText !== null"
            [attr.cdkFocusInitial]="modalConfig.modalAutofocus === 'cancel' || null"
            ui-button
            (click)="onCancel()"
            [buttonLoading]="!!modalConfig.modalCancelLoading"
            [disabled]="modalConfig.modalCancelDisabled">
            {{ modalConfig.modalCancelText || locale.cancelText }}
          </button>
          <button
            *ngIf="modalConfig.modalOkText !== null"
            [attr.cdkFocusInitial]="modalConfig.modalAutofocus === 'ok' || null"
            ui-button
            [buttonType]="modalConfig.modalOkType!"
            (click)="onOk()"
            [buttonLoading]="!!modalConfig.modalOkLoading"
            [disabled]="modalConfig.modalOkDisabled"
            [buttonDanger]="modalConfig.modalOkDanger">
            {{ modalConfig.modalOkText || locale.okText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
